import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import {
  AW_TYPE_CODE,
  IMAGING_TYPE_CODE,
  LAB_TYPE_CODE,
  URGENT_CARE_TYPE_CODE,
  TECH_CONNECT_CODE,
  URGENT_VISIT_TYPE_CODE,
} from '../../../constants';
import brandConfig from '../../../constants/brandConfig';
import {
  fullProviderSubtitle,
  transformProviderNameWithTitle,
} from '../../../utils/appointments/provider-details-formatter';

export function useAppointmentTitle({
  appointment,
  providerView,
  formatMessage,
  detailsView,
}) {
  const code = get(appointment, 'visitType.code');
  const location = get(appointment, 'location');
  const serviceName = get(appointment, 'service.name');
  const visitType = get(appointment, 'visitType.name', '');
  const organization = get(appointment, 'organization', {});
  const providerInfo = get(appointment, 'providerInfo');

  switch (code) {
    case AW_TYPE_CODE: {
      const i18n = 'healthboard.appointments.mobileAppAvailable';

      return {
        name: formatMessage({ id: i18n }),
        metaText: serviceName,
        noAvatar: true,
      };
    }
    case URGENT_CARE_TYPE_CODE:
    case IMAGING_TYPE_CODE:
    case LAB_TYPE_CODE:
    case TECH_CONNECT_CODE: {
      return {
        name: get(location, 'name'),
        metaText: serviceName,
        whiteAvatar: true,
        avatar: {
          thumbMin: get(organization, 'logo.thumbMin') || brandConfig.logoPath,
        },
      };
    }
    case URGENT_VISIT_TYPE_CODE: {
      return {
        name: providerInfo
          ? get(providerInfo, 'displayableName')
          : get(organization, 'name'),
        avatar: providerInfo
          ? get(providerInfo, 'avatar')
          : {
              thumbMin:
                get(organization, 'logo.thumbMin') || brandConfig.logoPath,
            },
        metaText: visitType,
        whiteAvatar: isEmpty(providerInfo),
      };
    }
    /**
     * All other appointment types
     * */
    default: {
      let provider = get(appointment, 'providerInfo', {});
      const metaText = providerView
        ? ''
        : fullProviderSubtitle({ ...provider, location });
      let name = get(provider, 'name');
      let avatar = get(provider, 'avatar');

      if (providerView) {
        const patient = get(appointment, 'patientUserInfo');
        const username = get(patient, 'username');
        name = get(patient, 'displayableName') || username;
        avatar = get(patient, 'avatar');
        provider = { name, avatar };
      }

      return {
        name: detailsView
          ? transformProviderNameWithTitle(provider).name
          : name,
        avatar,
        metaText,
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Healthboard/utils/useAppointmentTitle.js